// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b76b207c8755069e066b","655":"6c76c3099bad24078af2"}[chunkId] + ".js";
};